import React, {PureComponent} from 'react';
import Carousel from '../../components/multi-destination/carousel/Carousel';
import CardPopularDestinations from './CardPopularDestinations';
import EdapViewTracker from '../../components/common/edap-view-tracker/EdapViewTracker';
import PopularDestinationMap from '../../components/common/maps/map-component/PopularDestinationMap';

import './PopularDestinations.less';

const ACTIONLOCATION = 'destinations-component';

class PopularDestinations extends PureComponent {
    state = {
        highlightedItemLbsId: '',
        itemIndex: 1,
    };

    changeHighlightItem = (lbsId = '', index) => {
        this.setState((state) => ({
            highlightedItemLbsId: lbsId,
            itemIndex: index || state.itemIndex,
        }));
    };

    render() {
        const {itemIndex, highlightedItemLbsId} = this.state;
        const {destinations = [], isMobile, title} = this.props;
        const cardIndex = itemIndex > 6 ? 5 : itemIndex - 1;
        return (
            destinations.length >= 5 && (
                <section className="PopularDestinations section">
                    <div className="section--centered">
                        <h2 className="title">{title}</h2>
                        {!isMobile && (
                            <div className="Map__component">
                                <PopularDestinationMap
                                    {...{destinations, highlightedItemLbsId}}
                                    changeHighlightItem={
                                        this.changeHighlightItem
                                    }
                                    mapOptions={{
                                        disableDoubleClickZoom: false,
                                        draggable: true,
                                        mapTypeControl: false,
                                        scrollwheel: false,
                                        panControl: false,
                                        zoomControl: true,
                                        streetViewControl: false,
                                        mapTypeControlOptions: {
                                            position: 1,
                                        },
                                        fullscreenControl: false,
                                        fullscreenControlOptions: {
                                            position: 5,
                                        },
                                        scaleControl: false,
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    <Carousel
                        cardIndex={cardIndex}
                        actionlocation={ACTIONLOCATION}
                    >
                        {destinations.map((destination, i) => (
                            <CardPopularDestinations
                                key={`${destination.simpleName}${i}`}
                                itemNumber={i + 1}
                                changeHighlightItem={this.changeHighlightItem}
                                highlightedItemLbsId={highlightedItemLbsId}
                                {...destination}
                            />
                        ))}
                    </Carousel>
                    <EdapViewTracker
                        eventData={{actionlocation: ACTIONLOCATION}}
                    />
                </section>
            )
        );
    }
}

export default PopularDestinations;
